import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';

class ExpenseRequestsContainerState {
  store = new DomainStore();

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async removeExpenseRequest(expenseRequest) {
    return this.store.destroy(expenseRequest);
  }
}

export default ExpenseRequestsContainerState;
